import { React } from 'react';

// Renders `<prefix>.table`: column headers from its keys and one row per `<prefix>.table.rows.<row>`;
// the `level` column gets a colour per row key (low / medium / high)
const SatelliteTable = props => {
    const table = props.t(props.prefix, { returnObjects: true });
    const rows = Object.keys(table.rows);
    return (
        <div className='container-custom subtitle satellite-table'>
            <div className='table-responsive'>
                <table>
                    <thead>
                        <tr>
                            {props.columns.map(column => <th key={column}>{table[column]}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(row => (
                            <tr key={row}>
                                {props.columns.map(column => (
                                    <td key={column}>
                                        {column === props.level ? <span className={'level level-' + row}>{table.rows[row][column]}</span> : table.rows[row][column]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SatelliteTable;
